var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunnyBrothers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uADF8\\uB8F9 457",
    xmlns: "http://www.w3.org/2000/svg",
    width: 137,
    height: 151,
    viewBox: "0 0 137 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "so6dsa7gla"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 877",
    style: {
      fill: "none"
    },
    d: "M0 0h137v151H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g501zqirwb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 876",
    style: {
      fill: "none"
    },
    d: "M0 0h137v150.999H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p6clug40wc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 873",
    style: {
      fill: "none"
    },
    d: "M0 0h58.625v27.964H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 456",
    style: {
      clipPath: "url(#so6dsa7gla)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 455"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 454",
    style: {
      clipPath: "url(#g501zqirwb)"
    },
    transform: "translate(0 .001)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 447",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 446"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 445",
    style: {
      clipPath: "url(#p6clug40wc)"
    },
    transform: "translate(76.591 63.093)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 738",
    d: "M105.177 52.265c0 7.723-13.124 13.982-29.312 13.982s-29.313-6.259-29.313-13.982 13.124-13.982 29.314-13.982 29.312 6.259 29.312 13.982",
    transform: "translate(-46.553 -38.284)",
    style: {
      fill: "#333"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 450",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 449"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 448",
    style: {
      clipPath: "url(#p6clug40wc)"
    },
    transform: "translate(41.586 94.712)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 739",
    d: "M83.9 71.451c0 7.723-13.124 13.982-29.312 13.982s-29.312-6.259-29.312-13.982S38.4 57.469 54.59 57.469 83.9 63.728 83.9 71.451",
    transform: "translate(-25.277 -57.47)",
    style: {
      fill: "#333"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 740",
    d: "M102.666 43.11A26.966 26.966 0 1 1 75.7 16.1a26.989 26.989 0 0 1 26.966 27.01",
    transform: "translate(31.446 10.432)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 741",
    d: "M107.386 83.447a29.665 29.665 0 1 1 29.615-29.664 29.673 29.673 0 0 1-29.615 29.664m0-54.506a24.841 24.841 0 1 0 24.8 24.841 24.849 24.849 0 0 0-24.8-24.841"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 742",
    d: "M112.924 59.329a1.928 1.928 0 0 1-1.927-1.93v-4.824a1.927 1.927 0 1 1 3.853 0v4.824a1.928 1.928 0 0 1-1.927 1.93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 743",
    d: "M119.665 56.435a1.928 1.928 0 0 1-1.927-1.93v-4.828a1.927 1.927 0 1 1 3.853 0v4.824a1.928 1.928 0 0 1-1.927 1.93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 744",
    d: "M103.775 33.766a2.409 2.409 0 0 1-2.407-2.411v-8.689a2.407 2.407 0 1 1 4.814 0v8.684a2.409 2.409 0 0 1-2.407 2.416"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 745",
    d: "M59.289 37.171c1.884 1.721 2.7 3.891 1.833 4.849s-3.1.336-4.987-1.386-2.7-3.891-1.833-4.847 3.1-.336 4.987 1.384",
    transform: "translate(34.815 22.9)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 746",
    d: "M59.875 41.854c1.884 1.721 2.7 3.891 1.833 4.849s-3.1.336-4.987-1.386-2.7-3.891-1.833-4.847 3.1-.336 4.987 1.384",
    transform: "translate(35.193 25.935)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 747",
    d: "M65.143 41.854c1.884 1.721 2.7 3.891 1.833 4.849s-3.1.336-4.987-1.386-2.7-3.891-1.833-4.847 3.1-.336 4.987 1.384",
    transform: "translate(38.592 25.935)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 748",
    d: "m56.928 5.383 9.631 16.4L77.153 4.419S72.337.559 66.559 1.525s-9.631 1.928-9.631 3.858",
    transform: "translate(36.733 .887)",
    style: {
      fill: "#00dd4d"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 749",
    d: "M115.8 5.152c0-3.803-6.584-5.153-12.223-5.153s-12.224 1.35-12.224 5.153a3.011 3.011 0 0 0 .4 1.482 1.975 1.975 0 0 0 .171.428l8.924 15.963a3.131 3.131 0 0 0 2.72 1.574h.016a3.139 3.139 0 0 0 2.729-1.617l8.915-15.918a1.956 1.956 0 0 0 .171-.43 3.011 3.011 0 0 0 .4-1.482m-12.222-1.293a19.759 19.759 0 0 1 7.859 1.294 19.759 19.759 0 0 1-7.859 1.294 19.763 19.763 0 0 1-7.861-1.294 19.77 19.77 0 0 1 7.861-1.294m-.849 14.64-4.861-8.7a31.266 31.266 0 0 0 5.711.5 31.171 31.171 0 0 0 5.7-.5l-4.872 8.7a.962.962 0 0 1-1.68 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 750",
    d: "M116.596 68.494a5.545 5.545 0 0 1-1.991-.371 6.2 6.2 0 0 1-3.708-4.194 1.926 1.926 0 1 1 3.705-1.053 2.393 2.393 0 0 0 1.38 1.641 1.7 1.7 0 0 0 1.561-.17c.6-.377 1.158-.733 1.158-3.09a1.926 1.926 0 1 1 3.852 0c0 3.184-.854 5.023-2.952 6.352a5.608 5.608 0 0 1-3.006.883"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 751",
    d: "M80.243 62.618a26.966 26.966 0 1 1-26.966-27.012 26.989 26.989 0 0 1 26.966 27.012",
    transform: "translate(16.977 23.074)",
    style: {
      fill: "#fff"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 752",
    d: "M70.495 115.597a29.665 29.665 0 1 1 29.614-29.665 29.673 29.673 0 0 1-29.614 29.665m0-54.506a24.841 24.841 0 1 0 24.8 24.841 24.849 24.849 0 0 0-24.8-24.841"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 753",
    d: "M76.033 91.48a1.928 1.928 0 0 1-1.927-1.93v-4.824a1.927 1.927 0 1 1 3.853 0v4.824a1.928 1.928 0 0 1-1.927 1.93"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 754",
    d: "M76.435 98.578a1.93 1.93 0 0 1-.966-3.6l7.864-4.549a1.929 1.929 0 0 1 1.927 3.342l-7.864 4.549a1.9 1.9 0 0 1-.961.259"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 755",
    d: "M66.887 65.915a2.409 2.409 0 0 1-2.411-2.407V54.82a2.407 2.407 0 1 1 4.814 0v8.688a2.409 2.409 0 0 1-2.403 2.407"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 756",
    d: "M41.5 47.181c-1.718 1.887-3.884 2.708-4.84 1.836s-.336-3.11 1.384-5 3.884-2.708 4.839-1.836.336 3.108-1.382 5",
    transform: "translate(23.368 27.112)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 757",
    d: "M36.821 47.767c-1.718 1.887-3.884 2.708-4.84 1.836s-.334-3.11 1.384-5 3.884-2.703 4.835-1.831.336 3.108-1.382 5",
    transform: "translate(20.347 27.492)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 758",
    d: "M36.821 53.035c-1.718 1.887-3.884 2.708-4.84 1.836s-.336-3.11 1.384-5 3.884-2.708 4.839-1.836.336 3.108-1.382 5",
    transform: "translate(20.347 30.906)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 759",
    d: "m34.506 24.891 9.631 16.4 10.594-17.364s-4.817-3.86-10.594-2.894-9.631 1.928-9.631 3.858",
    transform: "translate(22.265 13.529)",
    style: {
      fill: "#00dd4d"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 760",
    d: "M78.908 37.303c0-3.8-6.584-5.153-12.223-5.153s-12.226 1.35-12.226 5.153a3.011 3.011 0 0 0 .4 1.482 1.975 1.975 0 0 0 .171.428l8.924 15.963a3.131 3.131 0 0 0 2.72 1.574h.016a3.139 3.139 0 0 0 2.729-1.617l8.922-15.919a1.955 1.955 0 0 0 .171-.43 3.011 3.011 0 0 0 .4-1.482M66.685 36.01a21.383 21.383 0 0 1 7.448 1.112.194.194 0 0 1 0 .361 21.333 21.333 0 0 1-7.448 1.114 21.344 21.344 0 0 1-7.45-1.114.194.194 0 0 1 0-.361 21.394 21.394 0 0 1 7.45-1.112m-.85 14.632L61.172 42.3a.188.188 0 0 1 .194-.28 31.777 31.777 0 0 0 5.319.432 31.658 31.658 0 0 0 5.309-.43.188.188 0 0 1 .2.28l-4.676 8.342a.962.962 0 0 1-1.68 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 761",
    d: "M82.773 88.586a1.928 1.928 0 0 1-1.927-1.93v-4.824a1.927 1.927 0 1 1 3.853 0v4.824a1.928 1.928 0 0 1-1.927 1.93"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 453",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 452"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 451",
    style: {
      clipPath: "url(#p6clug40wc)"
    },
    transform: "translate(0 123.036)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 762",
    d: "M58.624 88.637c0 7.723-13.124 13.982-29.312 13.982S0 96.36 0 88.637s13.123-13.982 29.312-13.982 29.312 6.259 29.312 13.982",
    transform: "translate(0 -74.656)",
    style: {
      fill: "#333"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 763",
    d: "M55.917 79.729a26.966 26.966 0 1 1-27.094-26.885 26.991 26.991 0 0 1 27.094 26.885",
    transform: "translate(1.281 34.245)",
    style: {
      fill: "#fff"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 764",
    d: "M30.614 144.006a29.665 29.665 0 1 1 29.474-29.81 29.674 29.674 0 0 1-29.474 29.81m-.257-54.51a24.841 24.841 0 1 0 24.916 24.728 24.85 24.85 0 0 0-24.916-24.728"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 765",
    d: "M36.038 119.862a1.927 1.927 0 0 1-1.935-1.92l-.023-4.824a1.926 1.926 0 1 1 3.852-.018l.023 4.824a1.927 1.927 0 0 1-1.917 1.938"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 766",
    d: "M42.765 116.935a1.927 1.927 0 0 1-1.935-1.92l-.026-4.824a1.926 1.926 0 1 1 3.852-.018l.023 4.824a1.927 1.927 0 0 1-1.917 1.938"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 767",
    d: "M26.767 94.341a2.409 2.409 0 0 1-2.419-2.4l-.041-8.684a2.408 2.408 0 1 1 4.816-.023l.039 8.684a2.409 2.409 0 0 1-2.4 2.423"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 768",
    d: "M12.561 73.948c1.89 1.712 2.721 3.88 1.856 4.839s-3.1.351-4.993-1.361-2.724-3.878-1.856-4.839 3.1-.351 4.993 1.361",
    transform: "translate(4.661 46.745)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 769",
    d: "M13.168 78.628c1.89 1.712 2.721 3.88 1.856 4.839s-3.1.351-4.993-1.361-2.723-3.878-1.856-4.839 3.1-.351 4.993 1.361",
    transform: "translate(5.053 49.778)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 770",
    d: "M18.436 78.6c1.89 1.712 2.721 3.88 1.856 4.839s-3.1.351-4.993-1.361-2.723-3.878-1.856-4.839 3.1-.351 4.993 1.361",
    transform: "translate(8.452 49.761)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 771",
    d: "m10.044 42.19 9.709 16.354L30.264 41.13s-4.834-3.837-10.607-2.845-9.623 1.974-9.613 3.9",
    transform: "translate(6.481 24.704)",
    style: {
      fill: "#00dd4d"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 772",
    d: "M38.659 65.671c-.018-3.8-6.609-5.12-12.247-5.094s-12.218 1.408-12.2 5.21a3 3 0 0 0 .4 1.48 1.948 1.948 0 0 0 .173.428l9 15.922a3.132 3.132 0 0 0 2.728 1.561h.015a3.142 3.142 0 0 0 2.723-1.632l8.847-15.96a1.929 1.929 0 0 0 .169-.432 3.025 3.025 0 0 0 .39-1.483M26.43 64.435a19.754 19.754 0 0 1 7.866 1.257 19.8 19.8 0 0 1-7.855 1.328 19.747 19.747 0 0 1-7.867-1.253 19.767 19.767 0 0 1 7.854-1.332m-.781 14.641-4.9-8.67a31.138 31.138 0 0 0 5.711.476 31.3 31.3 0 0 0 5.7-.527l-4.83 8.715a.962.962 0 0 1-1.68.007"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 773",
    d: "M25.214 124.664c.01-.073.02-.145.028-.219a.328.328 0 0 1-.02.079l.082-.2a.3.3 0 0 1-.041.069l.13-.166-.018.021 1.375.363v-.016l.03.219a.071.071 0 0 1 0-.026l-.03.219v-.021l-.082.2.01-.02-.128.166.015-.015-.166.129h.008a.92.92 0 0 0 .377-.493.618.618 0 0 0 .015-.328.6.6 0 0 0-.1-.307l-.128-.166a.831.831 0 0 0-.364-.213l-.219-.03a.817.817 0 0 0-.415.114.794.794 0 0 0-.189.148.926.926 0 0 0-.224.387.914.914 0 0 0 0 .5.833.833 0 0 0 .212.364.8.8 0 0 0 .364.211.816.816 0 0 0 .436 0 .8.8 0 0 0 .364-.211l.019-.026c.044-.054.09-.115.133-.173l.008-.01.025-.046a1.91 1.91 0 0 0 .1-.239l.007-.026v-.012c.012-.074.021-.153.031-.229a.623.623 0 0 0-.071-.318.733.733 0 0 0-.434-.435.62.62 0 0 0-.318-.071l-.219.03a.828.828 0 0 0-.364.211l-.128.168a.819.819 0 0 0-.112.415"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 774",
    d: "M19.4 80.361c-1.186-2.658-1.191-5.706-2.052-8.491-.041-.135-.1-.288-.232-.338a.465.465 0 0 0-.336.046 8.608 8.608 0 0 0-2.471 1.576 9.576 9.576 0 0 0-2.593 4.087 5.753 5.753 0 0 0-.329 2.4 2.972 2.972 0 0 0 1.109 2.08 4.435 4.435 0 0 0 3.435.341 1.885 1.885 0 0 0 1.287-.626",
    transform: "translate(7.333 46.346)",
    style: {
      fill: "#e54159"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 775",
    d: "M24.183 115.533a3.229 3.229 0 0 0-.183.343c-3.6-.368-7.024 3.013-7.619 6.426a8.08 8.08 0 0 0 1.234 5.734 6.114 6.114 0 0 0 5.368 2.71 8.488 8.488 0 0 0 4.406-1.7 10.252 10.252 0 0 0 1.489 1.025 16.343 16.343 0 0 0 4.289 1.4 10.606 10.606 0 0 0 4.574.27c2.741-.577 5.73-1.29 7.979-3.037 1.884-1.463-.214-4.539-2.108-3.065-1.7 1.318-3.758 1.716-5.791 2.268a10.664 10.664 0 0 1-6.588-.839 6.332 6.332 0 0 1-1.675-1.063 1.59 1.59 0 0 0-.271-.613 2.058 2.058 0 0 0-.831-.611 9.6 9.6 0 0 1-1.188-7.227 1.752 1.752 0 0 0-.11-1.811l-.036-.053a1.875 1.875 0 0 0-2.938-.16m-.288 8.45a10.783 10.783 0 0 0 1.035 2.199c-.158.1-.295.236-.459.326-.069.033-.265.133-.294.147-.23.1-.466.18-.7.259a.707.707 0 0 0-.133.053.979.979 0 0 0-.123.012 5.058 5.058 0 0 1-.652.054c-.048-.01-.306-.028-.349-.036a4.042 4.042 0 0 1-.395-.094c.12.036.118.03 0-.018-.072-.031-.55-.295-.392-.186a5.155 5.155 0 0 1-.4-.335c-.053-.053-.066-.066-.086-.084a6.023 6.023 0 0 1-.166-.213c-.1-.142-.191-.29-.281-.44-.107-.188-.114-.2-.023-.041a2.376 2.376 0 0 1-.1-.242 6.041 6.041 0 0 1-.206-.578 4.115 4.115 0 0 1-.087-1.979 5.034 5.034 0 0 1 .946-1.8c.153-.19.321-.364.489-.542a.643.643 0 0 0 .079-.094.7.7 0 0 0 .109-.071c.173-.124.339-.252.52-.363.077-.049.155-.1.235-.138-.151.082-.128.077.071-.015.173-.061.341-.127.518-.176-.212.059.044.02.242-.012v.193a12.794 12.794 0 0 0 .619 4.212"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnyBrothers);
export default __webpack_public_path__ + "static/media/funny_brothers.b24f2b651463fdad1c28fc449649fc53.svg";
export { ForwardRef as ReactComponent };